module.exports = __webpack_public_path__ + "static/media/arrowRightLight.4e12a340.svg";